import { Packr } from 'msgpackr';
import { MessageType } from '../types/protocol.js';
import { parseHeader, HEADER_SIZE } from './types.js';

const unpackr = new Packr({
  useRecords: false,
  moreTypes: true,
});

export function decodeMessage(buffer: ArrayBuffer): { type: MessageType; payload: unknown } {
  const { type } = parseHeader(buffer);
  const payloadBuffer = buffer.slice(HEADER_SIZE);
  const payload = unpackr.decode(new Uint8Array(payloadBuffer));
  return { type, payload };
}

export function decodeInput(buffer: ArrayBuffer): { type: MessageType; payload: { sequence: number; timestamp: number; dirX: number; dirY: number; inputMode: 'wasd' | 'mouse' | 'touch' } } {
  return decodeMessage(buffer) as any;
}

export function decodeConnect(buffer: ArrayBuffer): { type: MessageType; payload: { token: string; version: string; cosmetics: { skinId: string; trailId: string; collisionEffectId: string } } } {
  return decodeMessage(buffer) as any;
}

export function decodeUpgrade(buffer: ArrayBuffer): { type: MessageType; payload: { tree: string; level: number } } {
  return decodeMessage(buffer) as any;
}
